import React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ModalComponent from "../../../../components/Modal";
import { FaDownload } from "react-icons/fa";
import { requestDownloadFileById, setResetDownloadFileById } from "../../../../Redux/TimeSheetState/TimeSheetActionCreator";
import { toast } from "react-toastify";
import FormRow from "../../../../components/FormRow";
import FormField from "../../../../components/FormField";
import CustomDropdown from "../../../../components/CustomDropdown";

const ViewTimesheet = ({ show, onClose, projectsList = [] }) => {
  const dispatch = useDispatch();
  const downloadFileState = useSelector((state) => state.DownloadFileByIdReducer);
  const timesheetData = useSelector((state) => state.GetTimesheetByIdReducer?.Response);



  // Find the project from projectsList
  const project = React.useMemo(() => {
    if (!Array.isArray(projectsList) || !timesheetData?.projectId) return null;
    return projectsList.find(p => p.id === timesheetData.projectId) || null;
  }, [projectsList, timesheetData]);


  const handleDownloadFile = (e, file) => {
    e.preventDefault();
    e.stopPropagation();
        
    dispatch(requestDownloadFileById({
      tId: timesheetData?.id,
      fileId: file
    }));
  };

  // Handle download file state changes
  React.useEffect(() => {
    if (!downloadFileState?.loading && (downloadFileState?.response || downloadFileState?.error)) {
      if (downloadFileState?.error) {
        toast.error(downloadFileState?.error?.errorData?.data?.error || downloadFileState?.error?.errorData?.data || "Something went wrong");
      }
      
      if (downloadFileState?.response) {
        toast.success("File downloaded successfully");
      }
      
      dispatch(setResetDownloadFileById());
    }
  }, [downloadFileState, dispatch]);

  if (!timesheetData) {
    return null;
  }

  return (
    <ModalComponent
      show={show}
      onClose={onClose}
      title={
          <span className="text-indigo-500">View Timesheet</span>
      }
      className="w-full max-w-[95vw] sm:max-w-4xl mx-auto p-4 sm:p-6 max-h-[90vh] overflow-y-auto"
    >
      <div className="p-2">
        <div className="flex flex-col h-full overflow-y-auto max-h-[80vh]">
          <FormRow cols="sm:2" gap={2} className="flex-col sm:flex-row gap-2 sm:gap-4">
            <div className="relative w-full mt-2">
              <FormField
                type="text"
                name="projectName"
                value={project?.projectName || timesheetData?.projectName || ''}
                placeholder="Project"
                disabled={true}
                legend
                className="w-full text-xs sm:text-sm bg-gray-50"
              />
            </div>
            <div className="relative w-full mt-2">
              <FormField
                type="text"
                name="work_location"
                value={timesheetData?.work_location || ''}
                placeholder="Work Location"
                disabled={true}
                legend
                className="w-full text-xs sm:text-sm bg-gray-50"
              />
            </div>
          </FormRow>

          <FormRow cols="sm:2" gap={2} className="flex-col sm:flex-row gap-2 sm:gap-4">
            <div className="w-full relative">
              <FormField
                type="text"
                name="startDate"
                value={moment(timesheetData?.startDate, "MM-DD-YYYY").format("MM-DD-YYYY")}
                placeholder="Start Date"
                disabled={true}
                legend
                className="w-full text-xs sm:text-sm bg-gray-50"
              />
            </div>
            <div className="w-full relative">
              <FormField
                type="text"
                name="endDate"
                value={moment(timesheetData?.endDate, "MM-DD-YYYY").format("MM-DD-YYYY")}
                placeholder="End Date"
                disabled={true}
                legend
                className="w-full text-xs sm:text-sm bg-gray-50"
              />
            </div>
            <div className="w-full relative">
              <FormField
                type="text"
                name="total_hours"
                value={timesheetData?.total_hours}
                placeholder="Total Hours"
                disabled={true}
                legend
                className="w-full text-xs sm:text-sm bg-gray-50"
              />
            </div>

            {/* Rejection Reason Display */}
          {(timesheetData?.status === 'RESUB' || timesheetData?.status === 'REJ') && timesheetData?.remarks && (
            
              <div className="w-full relative">
                <FormField
                  type="text"
                  name="rejection_reason"
                  value={timesheetData.remarks}
                  placeholder="Rejection Reason"
                  disabled={true}
                  legend
                  className="w-full text-xs sm:text-sm bg-gray-50"
                />
              </div>
            
          )}

            
          </FormRow>

          

          

          {/* Holidays */}
          {timesheetData?.holidays && timesheetData.holidays.length > 0 && (
            <div className="mt-4">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-medium text-gray-700 text-sm sm:text-base">Holidays</h3>
              </div>
              <div className="space-y-3">
                {timesheetData.holidays.map((holiday, index) => (
                  <div
                    key={index}
                    className="p-3 border border-gray-200 rounded-lg bg-white shadow-sm"
                  >
                    <FormRow cols="1 sm:2" gap={2} className="flex-col sm:flex-row gap-2 sm:gap-4">
                      <div className="w-full relative">
                        <FormField
                          type="text"
                          name={`holiday_date_${index}`}
                          value={moment(holiday.employee_holiday_date, "MM-DD-YYYY" ).format("MM-DD-YYYY")}
                          placeholder="Holiday Date"
                          disabled={true}
                          legend
                          className="w-full text-xs sm:text-sm bg-gray-50"
                        />
                      </div>
                      <div className="w-full relative">
                        <FormField
                          type="text"
                          name={`holiday_notes_${index}`}
                          value={holiday.notes}
                          placeholder="Holiday Notes"
                          disabled={true}
                          legend
                          className="w-full text-xs sm:text-sm bg-gray-50"
                        />
                      </div>
                    </FormRow>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Attachments */}
          {timesheetData?.files && timesheetData.files.length > 0 && (
            <div className="mt-4">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-medium text-gray-700 text-sm sm:text-base">Attachments</h3>
              </div>
              <div className="space-y-2">
                {timesheetData.files.map((file) => (
                  <div
                    key={file.id}
                    className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200"
                  >
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                      <div className="flex-shrink-0">
                        <svg className="w-5 h-5 text-indigo-500" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-gray-900 truncate text-left">
                          {file.fileName}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={(e) => handleDownloadFile(e, file.id)}
                      disabled={downloadFileState?.loading}
                      className={`text-indigo-500 hover:text-indigo-700 transition-colors p-1 rounded ${
                        downloadFileState?.loading ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                      title={downloadFileState?.loading ? "Downloading..." : "Download file"}
                    >
                      <FaDownload className={`w-4 h-4 ${downloadFileState?.loading ? 'animate-pulse' : ''}`} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </ModalComponent>
  );
};

export default ViewTimesheet; 